import { useEffect, useState } from 'react'

import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'
import { CustomEvents } from 'shared/constants/customEvents'
import { useUserContext } from 'shared/hooks'

export const TaskModal = () => {
  const [selectedTaskId, setSelectedTaskId] = useState<string | null>(null)

  const { user } = useUserContext()

  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_TASKMANAGEMENT_APP_V2_DEV_PATH,
    'task_management',
    './TaskManagementAppComponents',
    'taskManagementAppV2'
  )

  // @ts-expect-error: dynamic import
  const { TaskManagementApp } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : { TaskManagementApp: () => <></> }

  const openTaskManagementTaskModal = (taskId: string) => {
    setSelectedTaskId(taskId)
  }

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return

      if (event.data?.type === CustomEvents.OPEN_TASK_MODAL) {
        const { taskId } = event.data.payload || {}
        if (taskId) {
          openTaskManagementTaskModal(String(taskId))
        }
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  if (!selectedTaskId) return null

  return (
    <TaskManagementApp
      user={user}
      path={`/tasks/${selectedTaskId}`}
      modalZIndex={17}
      onCloseExternalCallback={() => {
        setSelectedTaskId(null)
        window.postMessage(
          { type: CustomEvents.TASK_MODAL_CLOSED },
          window.location.origin
        )
      }}
    />
  )
}
